module.exports = __webpack_public_path__ + "static/media/punch_pedal.84739861.svg";